const DEFAULT_DATA = {
    'Origin': 'Homepage'
};

export {DEFAULT_DATA};